import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createPreset } from '@api/crowdCellPresets';

import { TOnSuccessOnError } from '@interfaces/common/handlers';
import { ICrowdCellsConfigPresetCreateDTO } from '@interfaces/crowdcell/dto/crowdCellsDTO';

import { ESnackbarTypes } from '@enums/common';

import { CROWD_CELL_CREATE_PRESETS, CROWD_CELL_PRESETS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useCreateConfigPreset({ onSuccess, onError }: Partial<TOnSuccessOnError>): {
	createConfigPreset: (preset: ICrowdCellsConfigPresetCreateDTO) => void;
	isPresetCreating?: boolean;
} {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: createConfigPreset,
		isLoading,
	} = useMutation<ICrowdCellsConfigPresetCreateDTO>({
		mutationFn: createPreset,
		onError: () => {
			if (onError) {
				onError();
			}

			dispatch(setSnackbar({
				message: responseMessages.error,
				type: ESnackbarTypes.error,
			}));
		},
		onSuccess: () => {
			if (onSuccess) {
				onSuccess();
			}

			return [
				queryClient.invalidateQueries([CROWD_CELL_PRESETS]),
			];
		},
		mutationKey: [CROWD_CELL_CREATE_PRESETS],
		invalidateQueries: [CROWD_CELL_PRESETS],
	});

	return {
		createConfigPreset,
		isPresetCreating: isLoading,
	};
}
